module.exports = __webpack_public_path__ + "img/afternoon_icon.7789c869.svg";